import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Tag, Typography } from '@guildeducationinc/recess';
import { EditCommentModal } from '@src/components/EditCommentModal';
import { TimeAgo } from '@src/components/TimeAgo';
import { useAuth } from '@src/hooks/useAuth';
import { getCommentCreatedBy } from '@src/utilities/commentHelper';
import classNames from 'classnames';
import { useLocale } from 'pe-core-frontend';
import { useState } from 'react';
import styles from './CommentCard.module.scss';
export const CommentCard = ({ comment }) => {
    const { t } = useLocale();
    const { currentUser } = useAuth();
    const [showModal, setShowModal] = useState(false);
    const isCurrentUser = currentUser?.id === comment.createdById;
    const commentCreatedBy = currentUser ? getCommentCreatedBy(t, currentUser, comment) : '-';
    const getMessage = (comment) => {
        if (isCurrentUser) {
            // show in original language if the user is the creator of the comment
            return comment.message;
        }
        // show in translated language if available
        return comment.extraData?.translatedText || comment.message;
    };
    return (_jsxs("div", { className: styles.commentBox, children: [_jsxs("div", { className: classNames(styles.commentHeader, isCurrentUser && styles.currentUser), children: [_jsx("div", { children: _jsx(Typography, { variant: 'label2', weight: '700', children: commentCreatedBy }) }), _jsxs("div", { className: styles.date, children: [comment.isInternal ? (_jsx(Tag, { appearance: 'quiet', color: 'yellow', children: t('Internal') })) : (_jsx(Tag, { appearance: 'quiet', color: 'grey', children: t('Public') })), "\u00A0", _jsx(Typography, { variant: 'label2', children: _jsx(TimeAgo, { date: comment.createdAt }) })] })] }), _jsx("div", { className: styles.commentContent, children: _jsx(Typography, { variant: 'body1', children: _jsx("span", { dangerouslySetInnerHTML: {
                            __html: getMessage(comment),
                        } }) }) }), _jsx(EditCommentModal, { required: true, comment: comment, isOpen: showModal, onClose: () => setShowModal(false) })] }));
};
